<template>
  <b-overlay
      :show="processing"
      rounded="sm"
  >

    <template v-slot:overlay>
      <div
          v-if="processing"
          class="text-center p-4 bg-primary text-light rounded"
      >
        <b-icon
            icon="cloud-download"
            font-scale="4"
        />
        <div class="mb-3 mt-2">
          منتظر بمانید ...
        </div>
        <b-progress
            min="1"
            max="60"
            :value="counter"
            variant="success"
            height="3px"
            class="mx-n4 rounded-0"
        />
      </div>
    </template>
    <b-card
        :title="$t('foods.pageTitle')"
    >
      <b-row>
        <b-col
            class="table-size"
        >
          <div class="custom-search">
            <b-row>
              <div class="filter-row">
                <b-button
                    variant="primary"
                    class="mb-1 ml-1"
                    :to="{ name: 'addfood'}"
                    v-text="$t('common.new')"
                />
                <b-button
                    variant="success"
                    class="mb-1 ml-1"
                    v-text="$t('common.update')"
                    @click="clearCache"
                />
                <b-button
                    variant="gradient-secondary"
                    class="mb-1 mr-auto ml-1"
                    v-text="$t('common.export')"
                    @click="exportExcel"
                />
                <b-col md="2">
                  <b-form-group
                      :label="$t('common.title')"
                      label-for="Title"
                  >
                    <b-form-input
                        v-model="filterOptions.Title"
                        autocomplete="off"
                        @keyup.enter="update(1)"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group
                      :label="$t('foods.key')"
                      label-for="FoodIndicatorId"
                  >
                    <z-food-indicator
                        v-model="filterOptions.FoodIndicatorId"
                        :multiple="false"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group
                      :label="$t('common.category')"
                      label-for="FoodCategoryId"
                  >
                    <z-food-category
                        v-model="filterOptions.FoodCategoryId"
                        :multiple="false"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group
                      :label="$t('foods.meal')"
                      label-for="FoodMealId"
                  >
                    <z-food-meal
                        v-model="filterOptions.FoodMealId"
                        :multiple="false"
                        :clearable="true"
                    />
                  </b-form-group>
                </b-col>
                <b-button
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    class="mb-1 mr-1"
                    variant="warning"
                    v-text="$t('common.filter')"
                    @click="update(1)"
                />
              </div>
            </b-row>
          </div>

          <b-table
              bordered
              hover
              striped
              :items="items"
              :fields="fields"
              class="mt-1 mb-2 position-relative"
              responsive
              :busy="loading"
              :no-local-sorting="true"
              :sort-by="filterOptions.SortBy"
              :sort-desc="filterOptions.IsDesc"
              @sort-changed="sortChange"
          >
            <template #cell(Id)="data">
              <b-link
                  :to="{ name: 'updatefood', params: { id: data.value }}"
                  class="font-weight-bold"
              >
                #{{ data.value }}
              </b-link>
            </template>

            <template #cell(Title)="data">
            <span class="text-nowrap">
              <b-avatar
                  class="mr-1"
                  :src="data.item.Image"
              />
              {{ data.value }}
            </span>
            </template>

            <template #cell(FoodCategory)="data">
            <span
                v-for="(item, index) in data.value"
                :key="index"
            >
              <b-badge
                  style="line-height: unset; margin: 2px;"
                  variant="info"
              >
                {{ item.Title }}
              </b-badge>
            </span>
            </template>

            <template #cell(Nature)="data">
              <b-badge
                  v-if="data.value"
                  variant="secondary"
              >
                {{ data.value.Title }}
              </b-badge>
            </template>

            <template #cell(actions)="data">
              <div
                  class="text-nowrap"
              >
                <feather-icon

                    icon="CopyIcon"
                    size="16"
                    class="mr-1 cursor-pointer"
                    @click="copy(data.item)"
                />

                <b-link :to="{ name: 'updatefood', params: { id: data.item.Id }}">
                  <feather-icon
                      :id="`invoice-row-${data.item.Id}-send-icon`"
                      icon="EditIcon"
                      size="16"
                  />
                </b-link>

                <feather-icon

                    icon="TrashIcon"
                    size="16"
                    class="ml-1 cursor-pointer"
                    @click="remove(data.item.Id)"
                />
              </div>
            </template>

            <template #table-busy>
              <div
                  class="text-center my-2"
              >
                <b-spinner
                    variant="primary"
                    class="align-middle"
                />
                <strong class="ml-1" v-text="$t('common.loading')" />
              </div>
            </template>

          </b-table>

          <z-pagination
              :page="filterOptions.Page"
              :total-rows="totalRows"
              :loading="loading"
              @change="update"
          />
        </b-col>
      </b-row>
      <b-modal
          v-model="showForm"
          v-if="showForm"
          :ok-title="$t('common.confirm')"
          :cancel-title="$t('common.cancel')"
          cancel-variant="outline-secondary"
          centered
          :title="selectedItem ? `${$t('foods.copyFood')} (${selectedItem.Title})`: $t('foods.copyFood')"
          :no-close-on-backdrop="true"
          size="sm"
          @ok="copyFood"
      >
        <b-col md="12">
          <b-form-group
              :label="$t('foods.newTitle')"
              label-for="Title"
          >
            <b-form-input v-model="form.NewTitle" name="Title" />
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group
              :label="$t('common.language')"
              label-for="Language"
          >
            <v-select
                v-model="form.Language"
                :options="enums('Language')"
                dir="rtl"
                label="text"
                name="Language"
                :clearable="false"
                :reduce="x => x.value"
            />
          </b-form-group>
        </b-col>
      </b-modal>
    </b-card>
  </b-overlay>
</template>

<script>

import ZFoodCategory from '@/tools/foodcategory.vue'
import ZFoodIndicator from '@/tools/foodindicator.vue'
import ZFoodMeal from '@/tools/foodmeal.vue'

export default {
  name: 'Food',
  components: {
    ZFoodCategory,
    ZFoodIndicator,
    ZFoodMeal,
  },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Page: 1,
        FoodCategoryId: null,
        FoodIndicatorId: null,
        FoodMealId: null,
        SortBy: 'Id',
        IsDesc: true,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
          sortable: true,
        },
        {
          key: 'Title',
          label: this.$t('common.title'),
          sortable: true,
        },
        {
          key: 'Calorie',
          label: this.$t('foods.calorie'),
          sortable: true,
        },
        {
          key: 'Nature',
          label: this.$t('foods.nature'),
        },
        {
          key: 'FoodCategory',
          label: this.$t('common.category'),
        },
        {
          key: 'Like',
          label: this.$t('foods.like'),
          sortable: true,
        },
        {
          key: 'Dislike',
          label: this.$t('foods.dislike'),
          sortable: true,
        },
        {
          key: 'Comment',
          label: this.$t('foods.opinion'),
          sortable: true,
        },{
          key: 'UsableCount',
          label: this.$t('foods.UsableCount'),
          thClass: 'col-width-50',
          sortable: true,
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
      form: {
        FoodId: '',
        Language: 0,
        NewTitle: '',
      },
      showForm: false,
      selectedItem: null,
      processing: false,
      counter: 1
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    sortChange(e) {
      if (e.sortBy) {
        this.filterOptions.SortBy = e.sortBy
        this.filterOptions.IsDesc = e.sortDesc
        this.update(1)
      }
    },
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.food.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearCache() {
      this.loading = true

      this.$http.post(
        this.$api.food.clearcache, null,
      )
        .then(res => {
          this.update()
        })
    },
    remove(id) {
      this.removeRow(this.$api.food.remove, 'Id', id)
    },
    copy(food) {
      this.form.FoodId = food.Id
      this.selectedItem = food
      this.showForm = true
    },
    copyFood() {
      this.loading = true
      if (!this.form.NewTitle && !this.form.Language)
        return this.$bvToast.toast(this.$t('common.fillAllFields'), {
          title: this.$t('common.errorAction'),
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          solid: false,
          appendToast: true,
        })
      this.$http.post(this.$api.food.copy, this.form)
          .then(() => {
            this.loading = false
            this.form.NewTitle = ''
            this.form.Language = 0
            this.update()
          }).finally(() => {
            this.loading = false
      })
    },
    exportExcel() {

      var This = this

      This.counter = 1
      This.processing = true

      let interval = setInterval(() => {
        This.counter += 1
      }, 1000)

      let filename = 'foods.xls'
      let xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.onreadystatechange = function() {
        if (xmlHttpRequest.readyState === 4 && xmlHttpRequest.status === 200) {

          let remaining = 60 - This.counter

          let interval2 = setInterval(() => {
            This.counter += 1
          }, 100)

          setTimeout(() => {

            let a = document.createElement('a')
            a.href = window.URL.createObjectURL(xmlHttpRequest.response)
            a.download = filename
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            a.remove()

            clearInterval(interval)
            clearInterval(interval2)
            This.processing = false

          },remaining * 100)
        }
      }
      let url = new URL(window.location.origin + '/api/food/excel')
      Object.entries(this.filterOptions).forEach(([key, value]) => {
        if (value !== null) url.searchParams.set(key, value)
      })
      xmlHttpRequest.open("GET", url)
      xmlHttpRequest.setRequestHeader('Content-Type', 'application/json')
      xmlHttpRequest.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('accessToken'))
      xmlHttpRequest.responseType = 'blob'
      xmlHttpRequest.send()
    },
  },
}
</script>
